import { Box, Divider, Pagination, Stack } from '@mui/material'


const ProductPaginate = (props) => {
    const { totalPage = 80, handlePageChange } = props;

    return (
        <Box sx={{
            mt: 3,
        }} >
            <Divider />
            <Stack spacing={2} alignItems="flex-end" my={1}>
                <Pagination
                    count={totalPage}
                    defaultPage={1}
                    shape="rounded"
                    onChange={handlePageChange}
                />
            </Stack>
        </Box>
    )
}

export default ProductPaginate